export const hasProperty = (object, propertyName) => Object.hasOwn(object, propertyName);
